













































import { Component, Vue, Watch } from 'vue-property-decorator';
import CodeEditor from '@/components/CppCodeEditor.vue';
import { RealmApi } from '@/services/api/api.realms';
import bus from '@/core/bus';
import { BusConstants, ModalConstants } from '@/core/constants';
import debounce from 'lodash-es/debounce';
import FilePicker from '@/components/dashboard/FilePicker.vue';
import { TDirectory, TFile } from '@/types/apiServerContract';
import urlHelperService from '@/services/url/urlHelper.service';

@Component({
    components: { CodeEditor, FilePicker }
})
export default class CoreScripts extends Vue {
    directories: TDirectory[] = [];
    selectedFile: TFile | null = null;
    fileContent: string = '';

    updateCoreFileDebounce = debounce(this.updateCoreFile, 1000);
    fileUpdateInProgress: boolean = false;
    fileIsInSyncWithServer: boolean = true;

    async getFileContent() {
        if (!this.selectedFile) return;
        this.fileContent = '';
        const result = await RealmApi.GetFileContent(this.selectedFile.fullPath);
	    this.fileContent = result.data;
    }

    async updateCoreFile() {
        if (!this.selectedFile) return;

        this.fileUpdateInProgress = true;
        this.fileIsInSyncWithServer = false;

        try {
            const result = await RealmApi.UploadFileContent({
                fileName: this.selectedFile.fullPath,
                content: this.fileContent
            });

            this.fileIsInSyncWithServer = result.data;
        } finally {
            this.fileUpdateInProgress = false;
        }
    }

    async createFolder(folderPath: string) {
        if (this.fileUpdateInProgress) return;

        this.fileUpdateInProgress = true;

        try {
            const result = await RealmApi.CreateCoreFolder(folderPath);
            if (result) {
	            this.directories = result.directories;
            }
        } finally {
            this.fileUpdateInProgress = false;
        }
    }

    async createFile(filePath: string) {
        if (this.fileUpdateInProgress) return;

        this.fileUpdateInProgress = true;

        try {
            const result = await RealmApi.CreateCoreFile(filePath);

            if (result) {
	            this.directories = result.directories;
            }
        } finally {
            this.fileUpdateInProgress = false;
        }
    }

    async deleteCoreFile() {
        if (!this.selectedFile) return;

        const check = await this.$bvModal.msgBoxConfirm('Are you sure you wish to delete this file?', {
	        centered: true,
	        okTitle: 'Yes'
	    });
	    if (!check) return;

        this.fileUpdateInProgress = true;

        try {
            const result = await RealmApi.DeleteCoreFile({
                fileName: this.selectedFile.fullPath
            });

            this.selectedFile = null;
            urlHelperService.removeQueryParam('selectedFile');

            if (result) {
                this.getCoreFiles();

                this.$bvToast.toast('File deleted successfully', {
                    variant: 'success',
                    title: 'Success'
                });
            }
        } finally {
            this.fileUpdateInProgress = false;
        }
    }

    @Watch('fileContent')
    onContentChange(a: string, b: string) {
        if (b.length !== 0 && a.length !== 0) {
            this.fileUpdateInProgress = true;
            this.updateCoreFileDebounce();
        }
    }

    async getCoreFiles() {
        this.selectedFile = null;
        this.fileContent = '';

        const result = await RealmApi.GetCoreFiles();
	    this.directories = result.directories;
    }

    saveAndBuild() {
        this.$bvModal.show(ModalConstants.BuildProcessWindow);
    }

    created() {
        this.getCoreFiles();

	    bus.on(BusConstants.SelectedRealmChanged, this.getCoreFiles);
    }

    beforeDestroy() {
	    bus.off(BusConstants.SelectedRealmChanged, this.getCoreFiles);
    }
}
